import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ImageModal = ({ imageUrl, onClose }) => {
    const [zoom, setZoom] = useState(1);

    return (
        <Modal show={!!imageUrl} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton className="d-flex align-items-center">
                <Modal.Title className="m-0">Image Preview</Modal.Title>
                <div className="flex-grow-1"></div>

                <div className="icon-btn-group">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Zoom In</Tooltip>}>
                        <button
                            className="btn btn-sm btn-outline-secondary icon-btn"
                            onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}
                        >
                            <i className="fas fa-plus-circle text-white"></i>
                        </button>
                    </OverlayTrigger>

                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Reset Zoom</Tooltip>}>
                        <button
                            className="btn btn-sm btn-outline-secondary icon-btn"
                            onClick={() => setZoom(1)}
                        >
                            <i className="fas fa-undo-alt text-white"></i>
                        </button>
                    </OverlayTrigger>

                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Zoom Out</Tooltip>}>
                        <button
                            className="btn btn-sm btn-outline-secondary icon-btn"
                            onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}
                        >
                            <i className="fas fa-minus-circle text-white"></i>
                        </button>
                    </OverlayTrigger>
                </div>
            </Modal.Header>

            <Modal.Body style={{ height: "600px", overflow: "auto", padding: 0 }}>
                <div
                    style={{
                        minWidth: `${zoom * 100}%`,
                        minHeight: `${zoom * 100}%`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "16px",
                    }}
                >
                    <img
                        src={imageUrl}
                        alt="Preview"
                        style={{
                            width: `${zoom * 65}%`,
                            height: "auto",
                            borderRadius: "8px",
                            display: "block",
                            transition: "width 0.2s ease",
                        }}
                    />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ImageModal;